import { useEffect } from 'react';

import { setEarlyFeatureCode } from '@/domain/early-feature/early-feature.action';
import { EarlyFeatureCodeValues } from '@/domain/early-feature/early-feature.entities';
import { useAppDispatch } from '@/ui/hook/store';

/**
 * This component receive user action from the console or url and trigger domain actions to enable early feature
 */
export function EarlyFeatureReceiver() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // option 1 : type "?early-feature=code" in the url
    const checkInUrl = () => {
      const code = window.location.search.split('early-feature=')[1];
      if (isCodeInEarlyFeatureList(code)) {
        console.log('🎮 early-feature enabled = ', code);
        dispatch(setEarlyFeatureCode(code));
      }
    };
    // option 2 : type earlyFeature('code') in the console
    const checkInConsole = () => {
      window.earlyFeature = (code: string) => {
        if (isCodeInEarlyFeatureList(code)) {
          console.log('🎮 early-feature enabled = ', code);
          dispatch(setEarlyFeatureCode(code));
        }
      };
    };
    checkInUrl();
    checkInConsole();
  });

  return <></>;
}

function isCodeInEarlyFeatureList(code: string): boolean {
  const list = EarlyFeatureCodeValues as readonly string[];
  return list.includes(code);
}
